import { useMemo } from 'react';
import { useAppSelector } from '../../app/hooks';
import { getSecondaryTabIds, isTabLockedForColumn } from '../../store/investor/taskTrackerResolution';
import { isEmpty } from '../../utils/utils';
import { useTaskTrackerResolution } from './useTaskTrackerResolution';

/**
 * Whether a dashboard tab is locked, read the same way the sidebar does. isTabLockedForColumn reads an
 * empty task tracker as locked, so this stays unlocked until the tracker resolves and falls back to the
 * resolution cache while a refresh has emptied the live map.
 */
export function useTabLocked(tabId: string): boolean {
    const tabLockStatus = useAppSelector((state) => state.investor.tabLockStatus as Record<string, { isLocked?: boolean }> | null);
    const taskTrackerMap = useAppSelector((state) => state.investor.taskTrackerMap as Record<string, { status?: string }> | null);
    const dashboardTabs = useAppSelector((state) => state.investor.config?.tabs);
    const secondaryModuleList = useMemo(() => getSecondaryTabIds(dashboardTabs) ?? [], [dashboardTabs]);
    const { resolved, cache } = useTaskTrackerResolution();
    const effectiveTaskTrackerMap = isEmpty(taskTrackerMap) ? cache : taskTrackerMap;
    return resolved && isTabLockedForColumn(tabId, tabLockStatus, effectiveTaskTrackerMap, secondaryModuleList);
}
